<template>
  <div class="welcome-page welcome-page--glass">
    <div class="welcome-glass-shell">
      <div class="welcome-page__content welcome-glass-stack">
        <header class="welcome-page__header welcome-header-glass">
          <button type="button" class="welcome-page__back" aria-label="Go back" @click="cancel">
            <i class="bi bi-arrow-left" aria-hidden="true"></i>
          </button>
          <h1 class="welcome-page__title">Welcome to AnnaBooks</h1>
        </header>

        <p class="welcome-page__subtitle welcome-subtitle-glass">
          Let's get started with setting up your company. Choose the option that best suits your needs.
        </p>

        <div class="welcome-page__cards">
          <article
            class="welcome-card welcome-card--glass"
            tabindex="0"
            :style="{ '--welcome-card-delay': '0.2s' }"
            @click="skipSetup"
            @keydown.enter="skipSetup"
            @keydown.space.prevent="skipSetup"
          >
            <div class="welcome-card__icon" aria-hidden="true">
              <i class="bi bi-lightning-charge-fill"></i>
            </div>
            <h2 class="welcome-card__title">Experienced User?</h2>
            <p class="welcome-card__text">
              Complete a streamlined 4-step setup process tailored for experienced users.
            </p>
            <span class="welcome-card__btn welcome-card__btn--primary">
              <i class="bi bi-arrow-right-short" aria-hidden="true"></i>
              Quick Setup
            </span>
          </article>

          <article
            class="welcome-card welcome-card--glass"
            tabindex="0"
            :style="{ '--welcome-card-delay': '0.28s' }"
            @click="startSetup"
            @keydown.enter="startSetup"
            @keydown.space.prevent="startSetup"
          >
            <div class="welcome-card__icon welcome-card__icon--alt" aria-hidden="true">
              <i class="bi bi-compass-fill"></i>
            </div>
            <h2 class="welcome-card__title">New to AnnaBooks?</h2>
            <p class="welcome-card__text">
              Let us guide you through the company setup process step by step.
            </p>
            <span class="welcome-card__btn welcome-card__btn--outline">
              <i class="bi bi-arrow-right-short" aria-hidden="true"></i>
              Start Setup
            </span>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './WelcomeCompany.css';
import './welcome-company-glass.css';
import logger from '@/utils/logger';

export default {
  name: 'WelcomeCompany',
  emits: ['start-setup', 'skip-setup', 'cancel'],
  methods: {
    skipSetup() {
      this.$emit('skip-setup');
    },
    startSetup() {
      this.$emit('start-setup');
    },
    cancel() {
      this.$emit('cancel');
    },
    async handleLogout() {
      try {
        await this.$store.dispatch('logout');
        await this.$router.push('/login');
      } catch (error) {
        logger.error('Logout error:', error);
      }
    },
  },
};
</script>
